import listFilter from "./listFilter.component";

const listFilterModule = angular
  .module("app.components.listFilter", [])
  .component("listFilter", listFilter);

export default listFilterModule;



// WEBPACK FOOTER //
// ./src/components/listFilter/listFilter.module.js